import { TooltipWrapper } from '@/ui/TooltipWrapper';
import { ShareDropdown } from './ShareDropdown';

type ShareData = {
  url: string;
  title: string;
  description: string;
};

type ShareButtonProps = {
  data: ShareData;
  onClick?: () => void;
};

interface ShareActionWithTooltipProps extends ShareButtonProps {
  translations?: Record<string, string>;
}

export const ShareActionButton = ({ data, translations, ...props }: ShareActionWithTooltipProps) => {
  if (translations?.['search.pagination.share']) {
    return (
      <TooltipWrapper portalId="post-actions-container" tooltipText={translations['search.pagination.share']}>
        <ShareDropdown title={data.title} description={data.description} url={data.url} {...props} />
      </TooltipWrapper>
    );
  }
  return <ShareDropdown title={data.title} description={data.description} url={data.url} {...props} />;
};
